import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const StudentsScoringInAssessments = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Students scoring >70% in assessments (%)" />
    </Box>
  );
};
